/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint dot-notation: 0 */
/* eslint spaced-comment: 0 */
import * as Blockly from 'blockly';
import { getAudioFromTag, loadAudioExt } from '../../../../helpers/LoadAndKillerScripts';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { PianoModal } from './customBlocks/pianoModal';
import { EducabotColourField, SIMPLE_GRID_COLOURS, SIMPLE_GRID_COLUMNS } from './customBlocks/colourPickerField';

Blockly.Blocks.colour_educabot = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput().appendField(
      new EducabotColourField('#ff0000', undefined, {
        colourOptions: SIMPLE_GRID_COLOURS,
        columns: SIMPLE_GRID_COLUMNS,
      }),
      'COLOUR',
    );
    this.setOutput(true, String);
    this.setTooltip(Blockly.Msg.LANG_Color);
    this.setColour(colors.COLOUR_SALIDAS);
  },
};
/////////////////////////////////
/////////////////////////////////

Blockly.Blocks.salidas_led2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(
        new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/18.svg`, options.blockWidth, options.blockHeight),
      )
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().appendField(
      new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]),
      'STAT',
    );
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_NEW)
      .appendField(
        new Blockly.FieldDropdown(() => {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`);
        }),
        'NPIN',
      );
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
    this.toggled = 0;
    const self = this;
  },
  getPins: function () {
    return ['NPIN'];
  },
  component: 'led',
};

Blockly.Blocks.led_neopixel_pin = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldImage(
          `${options.imgBase}/blocks/educablocks/181.svg`,
          options.blockWidth,
          options.blockHeight,
        ),
      )
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR').appendField(Blockly.Msg.LANG_BHOOT_LED_RGB);

    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_PIN_SINGLE)
      .appendField(
        new Blockly.FieldDropdown(() => {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`);
        }),
        'NPIN',
      );

    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LED_RGB_TOOLTIP);
  },
  component: 'ledRGB',
  getPins: () => ['NPIN'],
};

Blockly.Blocks.salidas_led_brillo = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/18.svg`, options.blockWidth, options.blockHeight),
      )
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOIN').appendField(Blockly.Msg.LANG_SALIDAS_LED_INTENSIDAD);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_PWM)
      .appendField(
        new Blockly.FieldDropdown(() => {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_NPIN`);
        }),
        'NPIN',
      );
    // Sin el true explícito v13 apila las entradas; el legacy lo fuerza.
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
  getPins: function () {
    return ['NPIN'];
  },
  component: 'led',
};

Blockly.Blocks.ENTRADAS_piezo_buzzer_piano = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldImage(
          `${options.imgBase}/blocks/educablocks/152.svg`,
          options.blockWidth,
          options.blockHeight,
        ),
      )
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput().appendField(
      new PianoModal({ basePitch: 165, octave: 3, duration: 1000, pinName: 'NPIN' }, undefined, {}),
      'PIANO',
    );
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO_PIN)
      .appendField(
        new Blockly.FieldDropdown(() => {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`);
        }),
        'NPIN',
      );
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
  // Lee y escribe la misma mutación `data-custom` que el legacy, para abrir proyectos guardados.
  mutationToDom: function () {
    const field = this.getField('PIANO');
    if (!field) return null;
    const { basePitch, octave, duration } = field.value_;
    const container = Blockly.utils.xml.createElement('mutation');
    container.setAttribute('data-custom', JSON.stringify({ basePitch, octave, duration }));
    return container;
  },
  domToMutation: function (xmlElement) {
    if (!xmlElement) return;
    const dataCustom = xmlElement.getAttribute('data-custom');
    if (!dataCustom) return;
    const field = this.getField('PIANO');
    if (!field) return;
    Object.assign(field.value_, JSON.parse(dataCustom));
  },
  saveExtraState: function () {
    const field = this.getField('PIANO');
    if (!field) return null;
    const { basePitch, octave, duration } = field.value_;
    return { basePitch, octave, duration };
  },
  loadExtraState: function (state) {
    const field = this.getField('PIANO');
    if (field) {
      Object.assign(field.value_, state);
    }
  },
  getPins: function () {
    return ['NPIN'];
  },
  component: 'buzzer',
};

Blockly.Blocks.ENTRADAS_piezo_buzzerno = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldImage(
          `${options.imgBase}/blocks/educablocks/152.svg`,
          options.blockWidth,
          options.blockHeight,
        ),
      )
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZERNO)
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIN)
      .appendField(
        new Blockly.FieldDropdown(() => {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`);
        }),
        'NPIN',
      );
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};
Blockly.Blocks.colour_bhoot = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput().appendField(
      new EducabotColourField('#ff0000', undefined, {
        colourOptions: ['#ff0000', '#00ff00', '#0000ff'],
        colourTitles: ['Rojo', 'Verde', 'Azul'],
        columns: 3,
      }),
      'COLOR',
    );
    this.setOutput(true, String);
    this.setTooltip(Blockly.Msg.LANG_Color);
    this.setColour(colors.COLOUR_SALIDAS);
  },
};

Blockly.Blocks.colour_bhoot_black_white = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput().appendField(
      new EducabotColourField('#000000', undefined, {
        colourOptions: ['#000000', '#ffffff'],
        colourTitles: ['Negro', 'Blanco'],
        columns: 2,
      }),
      'COLOR',
    );
    this.setOutput(true, String);
    this.setTooltip(Blockly.Msg.LANG_Color);
    this.setColour(colors.COLOUR_SALIDAS);
  },
};
